import React from 'react';
import * as classes from './CustomWithSpinner.module.scss';
import * as CustomDataBox from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";

const CustomWithSpinner = WrappedComponent => {
    const Spinner = (props) => {
        return props.isLoading ? (
            <div className={classes.CustomOverlay}>
                <div className={classes.SpinnerContainer}><h1>Google Analytics</h1><h2>loading...</h2><CustomDataBox.CustomSpinner isLoading={true} /></div>
            </div>) : (
                <WrappedComponent {...props} />
            )
    };

    return Spinner;
}


export default CustomWithSpinner;